import React from 'react';
import supplyChainIcon from '../../assets/in-transit.png';
import FeatureDetail from './FeatureDetail';

const SupplyChainManagement = () => {
  const benefits = [
    {
      title: 'End-to-End Visibility',
      description: 'Gain complete visibility into your entire supply chain from procurement to delivery.',
    },
    {
      title: 'Inventory Optimization',
      description: 'Reduce carrying costs while ensuring optimal inventory levels to meet demand.',
    },
    {
      title: 'Supplier Management',
      description: 'Evaluate supplier performance and maintain strong relationships with key partners.',
    },
    {
      title: 'Demand Forecasting',
      description: 'Accurately forecast demand to optimize procurement and production planning.',
    },
    {
      title: 'Logistics Optimization',
      description: 'Optimize shipping routes, carriers, and delivery methods to reduce costs and improve service.',
    },
    {
      title: 'Risk Mitigation',
      description: 'Identify and address potential supply chain disruptions before they impact your business.',
    },
  ];

  const useCases = [
    {
      title: 'Global Procurement',
      description: 'Manage suppliers across multiple regions with standardized processes and evaluations.',
    },
    {
      title: 'Just-in-Time Inventory',
      description: 'Implement JIT inventory systems to reduce storage costs and increase efficiency.',
    },
    {
      title: 'Distribution Network Optimization',
      description: 'Design and optimize your distribution network to reduce costs and improve service levels.',
    },
    {
      title: 'Returns Management',
      description: 'Streamline the returns process to recover value and improve customer satisfaction.',
    },
  ];

  const technologies = [
    { name: 'IoT Tracking', icon: '📍' },
    { name: 'RFID', icon: '📡' },
    { name: 'Blockchain', icon: '🔗' },
    { name: 'Predictive Analytics', icon: '📊' },
    { name: 'AI Planning', icon: '🤖' },
  ];

  const screenshots = [
    { 
      image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      caption: 'Supply chain visibility dashboard with real-time tracking'
    },
    { 
      image: 'https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      caption: 'Inventory management interface showing stock levels across locations'
    },
  ];

  return (
    <FeatureDetail
      title="Supply Chain Management"
      subtitle="Optimize your entire supply chain from procurement to delivery with real-time insights."
      description={
        <div>
          <p>
            Our Supply Chain Management solution provides comprehensive tools to optimize every
            aspect of your supply chain. From procurement and supplier management to warehouse
            operations and logistics, our platform helps you reduce costs, improve efficiency,
            and enhance customer satisfaction.
          </p>
          <p>
            With real-time tracking, predictive analytics, and intelligent optimization algorithms,
            you can make informed decisions that keep your supply chain running smoothly even in
            challenging market conditions.
          </p>
        </div>
      }
      icon={supplyChainIcon}
      benefits={benefits}
      useCases={useCases}
      technologies={technologies}
      mainImage="https://images.unsplash.com/photo-1565891741441-64926e441838?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
      screenshots={screenshots}
    />
  );
};

export default SupplyChainManagement;
